import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Configuration } from '../../models/configuration.model';
import { AuthLocalService } from './auth-local.service';
import { ConfigService } from '../../config.service';
import { ToastService } from './toast.service';

@Injectable()
export class Api {
  private config: Configuration;

  constructor(private http: HttpClient,
              private authLocalService: AuthLocalService,
              private configService: ConfigService,
              private toastService: ToastService) {
    this.config = this.configService.getConfiguration();
  }

  public get(endpoint: string, params?: HttpParams, options?): Observable<any> {
    options = this.handleOptions(options);
    if (!options.params) {
      options.params = new HttpParams();
    }
    // Support easy query params for GET requests
    if (params) {
      params.keys().forEach(paramKey => {
        options.params = options.params.set(paramKey, params.get(paramKey));
      });
    }

    return this.http.get(this.config.backendUrl + '/' + endpoint, options)
      .catch((error) => this.handleError(error));
  }

  public post(endpoint: string, body: any, options?): Observable<any> {
    options = this.handleOptions(options);
    return this.http.post(this.config.backendUrl + '/' + endpoint, body, options)
      .catch((error) => this.handleError(error));
  }

  public put(endpoint: string, body: any, options?): Observable<any> {
    options = endpoint === 'login' ? {} : this.handleOptions(options);
    return this.http.put(this.config.backendUrl + '/' + endpoint, body, options)
      .catch((error) => this.handleError(error));
  }

  public delete(endpoint: string, options?): Observable<any> {
    options = this.handleOptions(options);
    return this.http.delete(this.config.backendUrl + '/' + endpoint, options)
      .catch((error) => this.handleError(error));
  }

  public handleSuccess(result: any, message: string = 'Enregistrement réussi !') {
    this.toastService.showSuccess(message, 5000);
    return result;
  }

  private handleError(error) {
    console.error(error);
    this.toastService.showError(error.status);
    return Observable.throw(error);
  }

  private handleOptions(options) {
    if (!options) {
      options = Object.assign(new HttpParams());
    }
    options.headers = new HttpHeaders().set('Authorization', this.authLocalService.getAuthHeader());
    return options;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/util/api.ts